export const PAYMENT_REQUESTS_TABLE_TITLE = 'Payment Requests';
export const PAYMENT_REQUESTS_TABLE_INFO_URL = '';
